
import { Table } from "@/components/ui/table";
import { AttendanceTableHeader } from "./table/AttendanceTableHeader";
import { TableContent } from "./table/TableContent";
import { useAttendanceTable } from "./hooks/useAttendanceTable";
import { BookingData } from "@/types/types";

interface AttendanceTableProps {
  bookings: BookingData[];
  isLoading: boolean;
  getClassCapacity: (booking: BookingData) => number;
  getCurrentBookings: (className: string, date: string, time?: string) => number;
  attendeesData: {[key: string]: any[]};
  onRemoveClient?: (classId: string, userId: string, classDate: string, userName: string) => Promise<boolean>;
  onMarkAttendance?: (bookingId: string, attended: boolean, notes?: string) => Promise<boolean>;
  onRefreshData?: () => Promise<void>;
}

export const AttendanceTable = ({
  bookings,
  isLoading,
  getClassCapacity,
  getCurrentBookings,
  attendeesData,
  onRemoveClient,
  onMarkAttendance,
  onRefreshData
}: AttendanceTableProps) => {
  const {
    expandedRow,
    removingClientId,
    updatingAttendanceId,
    toggleExpandRow,
    handleRemoveClient,
    handleMarkAttendance
  } = useAttendanceTable({
    onRemoveClient,
    onMarkAttendance,
    onRefreshData
  });
  
  return (
    <div className="rounded-md border overflow-hidden">
      <Table>
        <AttendanceTableHeader />
        <TableContent
          bookings={bookings}
          isLoading={isLoading}
          getClassCapacity={getClassCapacity}
          attendeesData={attendeesData}
          expandedRow={expandedRow}
          updatingAttendanceId={updatingAttendanceId}
          removingClientId={removingClientId}
          onToggleExpand={toggleExpandRow}
          onMarkAttendance={(bookingId, attended, userName) => {
            return handleMarkAttendance(bookingId, attended, userName);
          }}
          onRemoveClient={(classId, userId, classDate, userName) => {
            return handleRemoveClient(classId, userId, classDate, userName);
          }}
        />
      </Table>
    </div>
  );
};
